module.exports = __webpack_public_path__ + "img/Poland.d02a205d.png";